import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { prefixClass } from '../../../../core/constants/constants';

export enum StepState {
    Active = 'active',
    Completed = 'completed',
    Idle = 'idle',
    InSubstep = 'in-substep',
}

export interface Step {
    id: number;
    title: string;
    state: StepState;
    route?: string;
    substeps?: Step[];
}

@Component({
    selector: 'app-step',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
})

export class StepComponent {
    @Input() steps: Step[] = [];
    prefixClass: string = prefixClass;

    constructor() {}

    isStepEnabled(step: Step): boolean {
        return step.state === StepState.Active || step.state === StepState.Completed;
    }

    getStepClasses(step: Step): string {
        const activeClass = step.state === StepState.Active ? 'step--active' : '';
        const completedClass = step.state === StepState.Completed ? 'step--completed' : '';

        return `${activeClass} ${completedClass}`;
    }

    getTitleClasses(step: Step): string {
        return step.state === StepState.Completed ? 'step__title--completed' : '';
    }

    showIcon(step: Step): boolean {
        return step.state === StepState.Completed;
    }

    get getPrimaryColor(): string {
      return 'var(--primary-color)';
    }

    get activeStep() {
        return this.steps.find(step => 
            (step.substeps && step.substeps.length > 0)
            ? step.substeps.some(substep => substep.state === StepState.Active)
            : step.state === StepState.Active
        );
    }

    getDashArray(): string {
      const step = this.activeStep;
      const total = this.steps.length - 1;
      const stepIndex = this.steps.indexOf(step!);
      const percent = (stepIndex / total) * 100;
      return `${percent}, ${100 - percent}`;
    }

}